export const USERS_URL = 'https://auth.amplience.net/users' as const;
